import { z } from 'zod'

import { nonEmptyArraySchema } from '@mntn-dev/utilities'

import { BidIdSchema, ProjectIdSchema } from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const ProjectOffersSentActivityDetailsSchema = ActivityTypeAndDataSchema(
  'project_offers_sent',
  z.object({
    projectId: ProjectIdSchema,
    bidIds: nonEmptyArraySchema(BidIdSchema),
    ...ActivityLinkTargets('project'),
  })
)
